import { z } from "zod";

import { looseArray } from "~/v2/api/looseParse";

/** Per-ID status from trading-api OMS CancelOrders. */
export const cancelOrderStatusSchema = z.object({
  id: z.string(),
  ok: z.boolean(),
  error: z.string().nullish(),
});

export const cancelOrdersResponseSchema = z.object({
  // `.nullish()` preserves null (looseArray alone would coerce null → []).
  statuses: looseArray(
    cancelOrderStatusSchema,
    "cancelOrders.statuses",
  ).nullish(),
});

export type CancelOrderStatus = z.infer<typeof cancelOrderStatusSchema>;
export type CancelOrdersResponse = z.infer<typeof cancelOrdersResponseSchema>;
